import coreStore from "./core-store";

const remoteResource = 'account/api/v1/queries';

const store = coreStore.searchQueryStore(coreStore.createCoreStore('accountQuery', remoteResource, 'accountQueries'))

export default store;